<script setup lang="ts">

const ServicesAiContent = defineAsyncComponent(() => import('~/components/molecules/ServicesAiContent.vue'));

definePageMeta({
  layout: "services-layout",
});
</script>

<template>
  <ServicesAiContent/>
</template>
